import styled from 'styled-components';
import { customMedia } from 'styles/utils';

export const MainWrapper = styled.nav`
  z-index: 1008;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
  //right: 0;
  //bottom: 0;
  //left: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${customMedia.greaterThan('medium')`
    display: none;
  `}
`;

export const CloseCircleBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5rem;
  min-width: 5rem;
  max-width: 5rem;
  height: 5rem;
  min-height: 5rem;
  max-height: 5rem;
  border-radius: 3rem;
  // margin: ${props => props.theme.spacing.large};
  background-color: ${props => props.theme.color.wfBlack};
`;
